/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: checked-out-package-list-component.ts
 *
 * Created by randysorensen on 1/4/18.
 */

'use strict';

function CheckedOutPackageListController(this: JS5Object, _: JS5Object, uiGridConstants: JS5Object) {

    //======//
    // Data //
    //======//

    const queryForGridData = (): void => {
        this.loadingIndicator.show = true;

        this.loadingIndicator.show = false;
    };


    //======//
    // Grid //
    //======//

    let gridColDefs = [
        //
        // ID
        //
        {
            field: 'id',
            type: 'number',
            width: '150',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 1,
            },
            displayName: 'ID',
        },

        //
        // Title
        //
        {
            field: 'title',
            type: 'string',
            width: '*',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0,
            },
            displayName: 'Title',
        },
    ];

    this.gridOptions = {
        rowSelection: false,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: false,
        columnDefs: gridColDefs,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
        },
        data: [],
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = (): void => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...',
        };

        queryForGridData();
    };

}

angular
.module('prism-ui.dashboard.checkin')
.component('checkedOutPackageList', {
    templateUrl: 'dashboard/packageCheckin/components/views/checkedOutPackageList/checked-out-package-list-template.html',
    controller: CheckedOutPackageListController,
    bindings: {
    }
});
